<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 px-3 pt-3>
            <div class="title">
              Encuestas UG | Inicio
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="mt-3 px-6">
        <div v-if="loading">
          <v-layout wrap>
              <v-flex
                  v-for="i in [1, 2, 3, 4]"
                  :key="'sk_pg_' + i"
                  xs12
                  sm6
                  md4
                  lg3
                  text-sm-right
                  px-3
                  py-3
              >
                  <v-skeleton-loader 
                      max-width="300" 
                      type="image" />
              </v-flex>
          </v-layout>
        </div>
        <v-row v-else-if="valido && !loading">
          <v-col 
            v-if="bandejaServicios"
            cols="12" 
            md="3" 
            xs="12"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 24 : 6"
                  class="mx-auto card-ug"
                  shaped
                  @click="$router.push({ name: 'BandejaServicios' })"
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      left>
                      mdi-format-list-bulleted-type
                    </v-icon>
                    <span class="title font-weight-light azul-ug">
                      Bandeja de Servicios
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col 
                        v-if="loadingInfo" 
                        class="py-1" 
                        cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col 
                        v-else 
                        class="py-1" 
                        cols="12"
                      >
                        Servicios
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ servicios }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col 
            v-if="bandejaEncuestas"
            cols="12" 
            md="3" 
            xs="12"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 24 : 6"
                  class="mx-auto card-ug"
                  shaped
                  @click="$router.push({ name: 'BandejaEncuestas' })"
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      left>
                      mdi-format-list-checks
                    </v-icon>
                    <span class="title font-weight-light azul-ug">
                      Bandeja de Encuestas
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col 
                        v-if="loadingInfo" 
                        class="py-1" 
                        cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col 
                        v-else 
                        class="py-1" 
                        cols="12"
                      >
                        Encuestas
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ encuestas }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
<v-col 
            v-if="serviciosCorreo"
            cols="12" 
            md="3" 
            xs="12"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 24 : 6"
                  class="mx-auto card-ug"
                  shaped
                  @click="$router.push({ name: 'BandejaCorreos' })"
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      left>
                      mail
                    </v-icon>
                    <span class="title font-weight-light azul-ug">
                      Servicios de Correo
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col 
                        v-if="loadingInfo" 
                        class="py-1" 
                        cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col 
                        v-else 
                        class="py-1" 
                        cols="12"
                      >
                        Cuentas Salientes
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ correos }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>



        </v-row>
        <v-alert 
            v-else 
            type="error">
            Usted no cuenta con el permiso para acceder a esta página.
        </v-alert>
      </v-card-text>
    </v-card>

    <v-snackbar
        key="snackbar_inicioadministrador"
        v-model="snackbarError"
        :bottom="true"
        :multi-line="true"
        color="error"
    >
      {{ textoError }}
      <v-btn 
        dark 
        text 
        @click="snackbarError = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getInformacionBandeja } from "@/api";

export default {
  name: "Inicio",
  components: {
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true,
      loadingInfo: true,
      snackbarError: false,
      textoError: "",
      bandejaServicios: false,
      servicios: 0,
      bandejaEncuestas: false,
      encuestas: 0,
       serviciosCorreo:false,
       correos:0
    };
  },
  computed: {
    ...mapState(["perfil", "encuestasRoles"]),
    ...mapGetters("oidc", ["oidcUser"]),
  },
  beforeMount () {},
  async mounted () {
    this.validarAcceso();
  },
  methods: {
    ...mapActions(['tienePermisoServicio','cargarPermisosServicio']),
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      self.snackbarError = false;
      self.textoError = "";
      
      await this.cargarPermisosServicio();

      if((self.perfil != undefined && self.perfil != null) || self.encuestasRoles.length > 0)
      {
        if(await self.tienePermisoServicio({permiso: 'Administrador Encuestas'}) == true ||
           await self.tienePermisoServicio({permiso: 'Coordinador'}) == true
        ){
          self.bandejaServicios = true;
        }

        if(await self.tienePermisoServicio({permiso: 'Administrador Encuestas'}) == true ||
           await self.tienePermisoServicio({permiso: 'Coordinador'}) == true ||
           self.encuestasRoles.length > 0
        ){
          self.bandejaEncuestas = true;
        }
      if(await self.tienePermisoServicio({permiso: 'Administrador Encuestas'}) == true ||
           await self.tienePermisoServicio({permiso: 'Coordinador'}) == true
        ){
          self.serviciosCorreo = true;
        }


        self.valido = true;
        self.loading = false;

        await self.getInfoBandejaInicio();

      } else {
        self.loading = false;
        self.valido = false;
      }

    },
    async getInfoBandejaInicio () {
      var self = this;
      self.loadingInfo = true;

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getInformacionBandeja();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.servicios = response.data.data.servicios;
              self.encuestas = response.data.data.encuestas;
               self.correos = response.data.data.correos;              
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loadingInfo = false;
      } catch (e) {
        self.loadingInfo = false;
        self.snackbarError = true;
        self.textoError = e;
      }
    }, 
  }
};
</script>

<style>
.card-ug {
  border: 1px solid #b5a36a !important;
}

.azul-ug {
  color: #0e345b !important;
}
</style>
